/* eslint-disable @typescript-eslint/no-unnecessary-condition */
interface Item {
    itemId: string;
    slotId: string;
}

export function combineConsecutiveItems(items: Item[]): (Item & { count: number })[] {
    const combinedItems: (Item & { count: number })[] = []; // Ensuring count is part of the type

    for (const currentItem of items) {
        // Skip combining if itemId is null, undefined, or an empty string
        if (currentItem.itemId === null || currentItem.itemId === '') {
            combinedItems.push({ ...currentItem, count: 1 });
            continue; // Skip the rest of the loop
        }

        // If combinedItems array is empty or the current item is not the same as the last combined item
        if (combinedItems.length === 0 || currentItem.itemId !== combinedItems.at(-1)?.itemId) {
            combinedItems.push({ ...currentItem, count: 1 });
        } else {
            const lastCombinedItem = combinedItems.at(-1);
            if (lastCombinedItem) {
                lastCombinedItem.count++;
            }
        }
    }

    return combinedItems;
}
